import React from 'react';
import { PercentageOutlined } from '@ant-design/icons';
import { formatNumberRu } from '../../../utils/numberFormat';
import styles from '../../../styles/components/Dialogs.module.scss';

interface MinPercentageDialogProps {
  type: 'amount' | 'percentage';
  entityType: 'revenue' | 'knr';
  inputValue: number;
  calculatedPercent: number;
  minAmount: number;
}

export const MinPercentageDialog: React.FC<MinPercentageDialogProps> = ({
  type,
  entityType,
  inputValue,
  calculatedPercent,
  minAmount,
}) => {
  const entityLabel = entityType === 'knr' ? 'КНР' : 'выручки';
  const typeLabel = type === 'amount' ? 'сумма' : 'процент';

  return (
    <div className={styles.minPercentageDialog}>
      <div className={styles.warningCard}>
        <PercentageOutlined className={styles.warningIcon} />
        <div>
          <div className={styles.warningLabel}>
            {type === 'amount'
              ? `Введённая ${typeLabel} ${entityLabel}: `
              : `Введённый ${typeLabel}: `}
          </div>
          <div className={styles.warningValue}>
            {type === 'amount'
              ? `${formatNumberRu(inputValue)} ₽`
              : `${inputValue.toFixed(5)}%`}
          </div>
          <div className={styles.warningHint}>
            {type === 'amount'
              ? `= ${calculatedPercent.toFixed(5)}% (меньше минимума 0.001%)`
              : `Меньше минимума 0.001%`}
          </div>
        </div>
      </div>

      <div className={styles.infoCard}>
        <div className={styles.infoLabel}>Минимальная сумма для 0.001%:</div>
        <div className={styles.infoValue}>{`${formatNumberRu(Math.ceil(minAmount))} ₽`}</div>
      </div>

      <div className={styles.questionText}>Установить минимальный процент 0.001%?</div>
    </div>
  );
};
